module.exports = __webpack_public_path__ + "img/y9.b372ade9.jpg";